import { css, cx } from "@emotion/css"

import { Link } from "components/Link"
import React from "react"

const styles = {
  container: css`
    display: flex;
    padding: var(--spacing-xs) 0;
  `,
  link: css`
    margin-right: var(--spacing-xxs);
    text-transform: capitalize;
  `,
}

type BreadcrumbsProps = {
  current?: string | React.FunctionComponentElement<"span">
  section?: string
  items?: Item[]
}

type Item = {
  backLink?: string
  to?: string
}

export default function Breadcrumbs(props: BreadcrumbsProps) {
  const { current, section, items } = props
  return (
    <div className={cx("BodyBody-sDark-greyRegular", styles.container)}>
      {!!section ? (
        <div className={styles.link}>
          <span color="textPrimary">{section}</span> /
        </div>
      ) : null}
      {!!items
        ? items?.map((i, idx) => (
            <div className={styles.link} key={idx}>
              <Link to={i?.to || "#"}>{i?.backLink}</Link> /
            </div>
          ))
        : null}
      <span color="textPrimary">{current}</span>
    </div>
  )
}
